<div class="titulo_h2">
    <h2 class="h2_tituloh2">{{titulo}}</h2>
</div>